import { httpClient } from "../http/httpClient"
import { PanDetails } from "../panService/getPanId"

export async function getProposalPan(id: string) {
  const { data } = await httpClient.get<PanDetails>(`/self-hire/transaction/${id}/proposal`)
  return data
}